import { useEffect, useRef, useState } from 'react'
import cx from 'classnames'

import Button from 'common/components/button'
import { ChevronDown, ChevronUp } from 'common/icons'

type Props = {
  text: string
}

const OverflowText = ({ text }: Props) => {
  const textContainerRef = useRef<HTMLDivElement>(null)
  const [isTextExpanded, setIsTextExpanded] = useState(false)
  const [isTextOverflowing, setIsTextOverflowing] = useState(false)

  useEffect(() => {
    const container = textContainerRef.current
    if (container) {
      requestAnimationFrame(() => {
        const tolerance = 1 // Add 1px tolerance for calculation quirks related to zoom level
        setIsTextOverflowing(
          container.scrollHeight > container.clientHeight + tolerance
        )
      })
    }
  }, [text, isTextExpanded])

  const shouldShowExpandTextButton =
    (isTextExpanded && !isTextOverflowing) || isTextOverflowing

  return (
    <div className="flex gap-2">
      {shouldShowExpandTextButton && (
        <Button
          variant="icon"
          aria-label={isTextExpanded ? 'collapse-text' : 'expand-text'}
          prefixIcon={
            isTextExpanded ? <ChevronUp size={4} /> : <ChevronDown size={4} />
          }
          onClick={() => setIsTextExpanded(!isTextExpanded)}
        />
      )}

      <p
        ref={textContainerRef}
        className={cx('text-xxs', {
          'max-h-17 line-clamp-3': !isTextExpanded,
        })}
      >
        {text}
      </p>
    </div>
  )
}

export default OverflowText
